import { useEffect } from 'react'
import { Link } from 'react-router-dom'

const TERMLY_SCRIPT_ID = 'termly-jssdk'
const TERMLY_SCRIPT_SRC = 'https://app.termly.io/embed-policy.min.js'
const TERMLY_POLICY_ID = '3ed71330-9191-4f27-b38b-d48bdd4cc635'

function PrivacyPage() {
  // Re-inject the Termly loader on every mount. The vendor snippet bails when
  // its script tag is already present, so on SPA back-navigation the embed
  // would otherwise stay blank.
  useEffect(() => {
    document.getElementById(TERMLY_SCRIPT_ID)?.remove()
    const script = document.createElement('script')
    script.id = TERMLY_SCRIPT_ID
    script.src = TERMLY_SCRIPT_SRC
    script.async = true
    document.body.appendChild(script)
    return () => {
      script.remove()
    }
  }, [])

  return (
    <div className="legal-page">
      <div className="legal-hero">
        <p className="legal-kicker">Vault Financial</p>
        <h1>Privacy Policy</h1>
        <p className="legal-subtitle">
          How Vault Financial uses and protects linked financial account data.
        </p>
      </div>

      <div
        className="legal-termly-embed"
        dangerouslySetInnerHTML={{
          __html: `<div name="termly-embed" data-id="${TERMLY_POLICY_ID}"></div>`,
        }}
      />

      <div className="legal-grid">
        <section className="legal-card">
          <h2>Need help?</h2>
          <p>
            For privacy requests or account questions, use in-app account deletion from Account Settings
            or contact <a href="mailto:support@vaultfinance.ai">support@vaultfinance.ai</a>.
          </p>
        </section>
      </div>

      <div className="legal-actions">
        <Link to="/" className="btn btn-primary">
          Return Home
        </Link>
        <Link to="/support" className="btn btn-secondary">
          Contact Support
        </Link>
      </div>
    </div>
  )
}

export default PrivacyPage
